export enum MachineType {
    Standard,
    Template,
}

export interface IMachine {
    id: number;
    type: 'Standard' | 'Template';
    name: string;
    description: string;
    robotVersions: Array<{
        count: number,
        version: string,
    }>;
    licenseKey: string;
    nonProductionSlots: number;
    unattendedSlots: number;
}
